/* eslint-disable */
import React from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Box, Grid, CardContent, Stack, Typography } from "@mui/material";
import { FilepondWrapper } from "@/components/forms";
import { LoadingButton } from "@mui/lab";
import MenuItemModalForm from "@/components/modal/MenuItemModalForm";
import { TLogoForm } from "@/features/user/logo/types";
import FallbackImage from "@/components/images/fallback";
import NoImage from "@/components/images/noImage";
import DownloadFileButton from "@/components/downloads/DownloadFileButton";
import SimpleSpinner from "@/components/spinner/simpleSpinner";
/*
import {Debug} from "mui-rff";
*/

const LogoForm = (
    {
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        ponds,
        isModal,
        logo,
        showLogo,
        closePopover,
        logoName,
        downloadProps,
        setModalOpen,
        loading
    }: any
): any => {
    const [t] = useTranslation();

    const formFields: any[] = [

        {
            field: "ponds",
            values: ponds
        },
        {
            field:
                <Typography variant={'caption'}>
                    {t("logo.logo_file_text")}
                </Typography >
        },
        {
            field:
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent={{ md: 'space-between', sm: 'flex-start' }}
                    alignItems="center"
                    spacing={2}
                >

                    <Stack
                        direction={'column'}
                        justifyContent={{ md: 'space-between', sm: 'flex-start' }}
                        alignItems="center"
                        spacing={1}
                    >
                        {
                            (showLogo && logoName) && <span style={{ fontWeight: "bold", marginBottom: 4 }}>{logoName}</span>
                        }
                        {
                            (!showLogo && logo === null) && <NoImage />
                        }
                        {
                            showLogo && <DownloadFileButton {...downloadProps} component={<FallbackImage src={logo} />} />
                        }
                    </Stack>

                </Stack>

        }
    ]

    const modalProps: any = {
        hasMenuItem: true,
        label: t('logo.title'),
        title: t('logo.modal_title'),
        formFields,
        onSubmit,
        initialValues,
        validateForm,
        required,
        submitting,
        isUpload: true,
        closePopover,
        setModalOpen,
        loading
    }

    return (
        <>
            {
                !isModal &&
                <Form
                    onSubmit={onSubmit}
                    initialValues={initialValues}
                    validate={validateForm}
                    render={({ handleSubmit, errors, touched }) => {
                        //console.log('logo', logo);
                        //console.log('showLogo', showLogo);
                        return (
                            <>
                                {loading && <SimpleSpinner/>}
                                {!loading &&
                                    <form onSubmit={handleSubmit} noValidate>
                                        {formFields.map((item: any, idx: number) => (
                                            <div key={idx} >
                                                {
                                                    (item.field === "ponds") ?
                                                        <>
                                                            {
                                                                item.values.map((pond: any, index: number) => {
                                                                    return (
                                                                        <Box
                                                                            key={'box-ck-' + index}
                                                                        >
                                                                            <FilepondWrapper
                                                                                key={'pond-ck-' + index}
                                                                                authorization={pond.authorization}
                                                                                {...pond}
                                                                                hasError={errors[`${pond.formFieldName}`]}
                                                                                isTouched={touched[`${pond.formFieldName}`]}
                                                                                required={required[`${pond.formFieldName}`]}
                                                                            />
                                                                        </Box>

                                                                    );
                                                                })
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            {item.field}
                                                        </>
                                                }
                                            </div>
                                        ))}

                                        <LoadingButton
                                            sx={{ mt: 3, mr: 1 }}
                                            //fullWidth
                                            size="large"
                                            type="submit"
                                            variant="contained"
                                            loading={submitting}
                                        >
                                            {t('common.upload')}
                                        </LoadingButton>

                                        {/*<Debug/>*/}
                                    </form>
                                }
                            </>
                        )
                    }}
                />
            }

            {
                isModal &&
                <MenuItemModalForm
                    {...modalProps}
                />
            }
        </>


    );
}
export default LogoForm;
